import React from 'react';

/**
 * Catches render-time errors anywhere below it so a thrown component
 * shows a recoverable message instead of a blank white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            gap: '16px',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <h1 style={{ margin: 0, fontSize: '20px' }}>Something went wrong</h1>
          <p style={{ margin: 0, color: '#666' }}>
            The page failed to load. Please try again.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '8px',
              background: '#111',
              color: '#fff',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Go to COSMIC home
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
